import type { LucideProps } from 'lucide-react';
import type { ComponentType } from 'react';
import * as styles from './index.css';

const sizes = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 24,
    '5xl': 40,
} as const;

export type IconSize = keyof typeof sizes;

export interface IconProps extends Omit<LucideProps, 'size'> {
    icon: ComponentType<LucideProps>;
    size?: IconSize;
}

export function Icon({ icon: LucideIcon, size = 'md', ...props }: IconProps) {
    return <LucideIcon className={styles.icon} size={sizes[size]} {...props} aria-hidden="true" />;
}
